import React from 'react';
import Head from '../layout/head.jsx'
import Content from '../layout/content.jsx'
import Form from '../layout/form.jsx'
import Loader from '../layout/loader.jsx'
import { toast } from 'react-toastify'
import API from '../../services/api.jsx'
import Helpers from "../../services/helpers.jsx";
import DB from '../../services/db.jsx';
class ClientNew extends React.Component {
	constructor(props) {
		super(props)

		const fields = {
      name: { label: 'Name', type: 'text', required: true },
      affiliates: {
        label: 'Assigned affiliate(s)',
        type: 'select-multi',
        optionKey: 'affiliates',
        fullWidth: true,
        required: false,
        options: [],
        hidden:
          (Helpers.isSuperAdmin() || Helpers.checkPermissions('clients:edit')
            ? false
            : true) || DB.get('user').affiliates.length === 1,
      },
      users: {
        label: 'Add extra user(s) - Optional',
        type: 'select-multi',
        optionKey: 'users',
        fullWidth: true,
        required: false,
        options: [],
        hidden: !Helpers.checkPermissions(['users:edit', 'users:delete'], true),
        tooltip: `Grant access to a specific user
					Use this field to give a user access to this client (e.g. an account manager).
					Please note:
					- Account Managers can only see the clients they’ve created, unless granted access here.
					- Affiliate Admins and Managers automatically have access to all clients linked to their Affiliate.
					`,
      },
    };


		this.state = {
			loading: true,
			breadcrumb: {title: 'Back to client view', path: '/clients/' + props.match.params.clientId + '/campaigns'},
			fields,
			entity: null
		}
		this.saveEntity = this.saveEntity.bind(this)
	}

	componentDidMount() {
		this.loadClient();
		// this.loadUserOptions();
		// this.loadAffiliateOptions();
	}

	loadClient() {
		API.getClient(this.props.match.params.clientId).then((client) => {
			this.setState({
				loading: false,
				entity: client
			});
		});
	}

	// loadAffiliateOptions() {
  //   API.getAffiliates().then((entities) => {
  //     const affiliates = entities?.data?.map((affiliate) => ({
  //       key: affiliate.id,
  //       label: affiliate.name,
  //     }));
  //     this.setState((prevState) => ({
  //       fields: {
  //         ...prevState.fields,
  //         affiliates: { ...prevState.fields.affiliates, options: affiliates },
  //       },
  //     }));
  //   });
  // }

	// loadUserOptions() {
  //   API.getUsers().then((entities) => {
  //     const users = entities?.data?.map((user) => ({
  //       key: user.id,
  //       label: user.name,
  //     }));
  //     this.setState((prevState) => ({
  //       fields: {
  //         ...prevState.fields,
  //         users: { ...prevState.fields.users, options: users },
  //       },
  //     }));
  //   });
  // }

	saveEntity(fields) {
		if (!Helpers.checkPermissions("clients:edit")) {
      toast.error("You do not have permission to save it");
      return;
    }

		this.setState({ loading: true })
		API.update('clients', this.props.match.params.clientId, fields).then(() => {
			toast.success('Client has been updated')
			this.props.history.push('/clients/' + this.props.match.params.clientId + '/campaigns')
		}).catch(() => {
			// toast.error('An unexpected error has occured, please try again')
			this.setState({ loading: false })
		})
	}

	render() {
		if(this.state.loading)
			return <Loader />
		else
			return <>
				<Head title={'Edit client'} breadcrumb={this.state.breadcrumb} />
				<Content>
					<Form fields={this.state.fields} cancel={() => this.props.history.push('/clients/' + this.props.match.params.clientId + '/campaigns')} save={this.saveEntity} entity={this.state.entity} />
				</Content>
			</>
	}
}

export default ClientNew;
